<script>

export default {
  name: "BootstrapCollapse",
  props: {
    name_of_collapse: {
      type: String,
      required: true,
    },
    open_by_default: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_open: this.open_by_default,
      collapseId: 'collapse-' + Math.random().toString(36).substring(2, 10),
    }
  },
  mounted() {
    this.$refs.collapse_object.addEventListener("show.bs.collapse",  () => {
      this.is_open = true
    })
    this.$refs.collapse_object.addEventListener("hide.bs.collapse",  () => {
      this.is_open = false
    })
  }
}
</script>

<template>
  <button type="button" class="toggle-label" data-bs-toggle="collapse" :data-bs-target="'#' + collapseId"
       :aria-expanded="String(is_open)" :aria-controls="this.collapseId" ref="collapse_header">
    <span class="toggle-title h2">
      {{name_of_collapse}}
      <span><i class="fa-solid " :class="{'fa-chevron-up': is_open, 'fa-chevron-down': !is_open}"></i></span>
    </span>
  </button>
  <hr/>

  <div v-if="!open_by_default" class="collapse mt-2" :id="this.collapseId" ref="collapse_object">
    <slot name="objects"></slot>
  </div>
  <div v-else class="collapse mt-2 show" :id="this.collapseId" ref="collapse_object">
    <slot name="objects"></slot>
  </div>


</template>

<style scoped>
.toggle-label {
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
}

.toggle-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
}
</style>
